import request from "root/js/request";

export const postUploadOwnStock = async ({ cabinet_id }, formData) => {
  const file = formData.get("excel_file");
  if (file) {
    formData.delete("excel_file");
    formData.append("file", file);
  }
  formData.append("cabinet_id", cabinet_id);

  const response = await request({
    url: `/api/analytics/wh_supply/own_stock/`,
    method: "post",
    params: {
      cabinet_id,
    },
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    },
  });

  return response;
};

export const postDeleteOwnStock = async ({ cabinet_id }) => {
  const response = await request({
    url: `/api/analytics/wh_supply/own_stock/clear/`,
    method: "post",
    params: {
      cabinet_id,
    },
  });
  return response.data;
};

export const getOwnStock = async ({ cabinet_id }) => {
  const response = await request({
    url: `/api/analytics/wh_supply/own_stock/`,
    method: "get",
    params: {
      cabinet_id,
    },
  });
  return response.data;
};
